import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateGetChatMessages = {
  getChatMessages: { data: null, loading: false, error: null },
};

export const getChatMessages = createAsyncThunk('user/getChatMessages', async ({ chatId, ...data }, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .get(`${process.env.REACT_APP_SERVER_API}/chat/chats/${chatId}/messages`, {
      params: data,
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGetChatMessages = {
  [getChatMessages.pending]: (state) => {
    // state.getChatMessages.data = null;
    state.getChatMessages.loading = true;
    state.getChatMessages.error = null;
  },
  [getChatMessages.fulfilled]: (state, action) => {
    state.getChatMessages.loading = false;
    state.getChatMessages.data = action.payload;
    state.getChatMessages.error = null;
  },
  [getChatMessages.rejected]: (state, action) => {
    state.getChatMessages.loading = false;
    state.getChatMessages.error = action.payload;
  },
};
